export interface IIdAndName {
  id?: number;
  name?: string;
}
